import { Builder } from '@builder.io/react';
import { UserwayCustomTrigger } from '@hc-frontend/core-ui';

Builder.registerComponent(UserwayCustomTrigger, {
  name: 'UserwayButton',
  noWrap: false,
});
